export default function Button({ children, variant="primary", className="", ...props }) {

  const base = "px-4 py-2 rounded-xl font-semibold transition-all text-sm";

  const styles = {
    primary: "bg-[#FF4A1F] text-white hover:bg-[#e0431c]",
    outline: "border border-gray-300 hover:bg-gray-50",
    ghost: "text-gray-600 hover:bg-gray-100",
  };

  return (
    <button className={`${base} ${styles[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
